import React from "react"
import types from "prop-types"
import Formsy from "formsy-react"
import useSubmit from "hooks/useSubmit"
import { PrimaryButton } from "shared/buttons"
import GroupName from "./GroupName"
import GroupDescription from "./GroupDescription"

const GeneralTab = ({ group, updateGroup }) => {
  const { canSubmit, enableSubmit, disableSubmit } = useSubmit()

  return (
    <>
      <h2 className="tab-title">General</h2>
      <Formsy
        onSubmit={updateGroup}
        onValid={enableSubmit}
        onInvalid={disableSubmit}
        preventDefaultSubmit
      >
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-4">
            <GroupName group={group} />
            <GroupDescription group={group} />
          </div>
          <PrimaryButton
            className="w-full lg:max-w-max lg:self-center"
            text="Save changes"
            type="submit"
            disabled={!canSubmit}
          />
        </div>
      </Formsy>
    </>
  )
}

GeneralTab.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  group: types.object.isRequired,
  updateGroup: types.func.isRequired,
}

export default GeneralTab
